import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'

import BackgroundImage from '../../assets/images/background.png'
import GroupImage from '../../assets/images/group.png'
import Icon from '@material-ui/core/Icon'
import moment from 'moment'
import _ from 'lodash'

import BrandPicker from './../../components/BrandPicker'
import ModelPicker from './../../components/ModelPicker'
import YearPicker from './../../components/YearPicker'
import ProvincePicker from './../../components/ProvincePicker'
import GenderPicker from './../../components/GenderPicker'
import AddressPicker from './../../components/AddressPicker'
import DatePicker from 'react-mobile-datepicker'

import IconButton from '@material-ui/core/IconButton'
import Modal from '@material-ui/core/Modal'

import provinces from '../../data/provinces'
import districts from '../../data/districts'
import subdistricts from '../../data/subdistricts'
import newInfo from '../../assets/motor/newinfo.jpg'
import ReactImageMagnify from 'react-image-magnify'
import numeral from 'numeral'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const dateStringToText = (inputdate = '0001-01-01') => {
  const date = new Date(inputdate + 'T07:00:00')
  return date.toLocaleDateString('th-TH', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

String.prototype.replaceAll = function(search, replacement) {
  var target = this
  return target.replace(new RegExp(search, 'g'), replacement)
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backgroundImageContainer: {
    position: 'absolute',
    height: '160px',
    width: '100%',
  },
  backgroundImage: {
    height: '160px',
    objectFit: 'cover',
    width: '100%',
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(94, 92, 92, 0.3)',
    backgroundImage: 'linear-gradient(162deg, #ffffff, #ffffff)',
    margin: '16px',
  },
  cardHeader: {
    backgroundColor: '#ddedfe',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '16px',
  },
  cardTitle: {
    color: '#0e162c',
    fontSize: '18px',
    ...fontDefault,
  },
  cardContent: {
    padding: '16px',
  },
  container: {
    marginTop: '10px',
    position: 'relative',
  },
  fieldTitle: {
    ...fontDefault,
    fontSize: '16px',
    color: '#0e162c',
  },
  inputContainer: {
    border: '1px solid #ffffff',
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputContainerDisable: {
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#EFEFEF',
  },
  inputContainerInput: {
    border: '1px solid #ffffff',
    marginTop: '7px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputContainerDisableError: {
    border: '1px solid #ff4d4f',
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#EFEFEF',
  },
  inputContainerError: {
    border: '1px solid #ff4d4f',
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputContainerInputError: {
    border: '1px solid #ff4d4f',
    marginTop: '7px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fieldValueBlank: {
    color: '#cdd2de',
  },
  fieldValue: {
    color: '#0e162c',
  },
  fieldInput: {
    width: '100%',
    padding: '16px',
    ...fontDefault,
    fontSize: '16px',
    color: '#333333',
    borderRadius: '8px',
    border: 'none',
    '&:focus': {
      outlineWidth: '0',
    },
    '&::placeholder': {
      color: '#cdd2de',
    },
  },
  errorText: {
    display: 'block',
    marginTop: '8px',
    ...fontDefault,
    color: '#ff4d4f',
    fontSize: '14px',
  },
  button: {
    cursor: 'pointer',
    width: '18px',
    height: '18px',
    marginLeft: '6px',
  },

  modalContainer: {
    outline: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    width: '90%',
    maxHeight: '80%',
    backgroundColor: 'white',
    borderRadius: '8px',
  },
  modalContent: {
    overflowY: 'auto',
    padding: '15px',
  },
  modalClose: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
  modalHeader: {
    padding: '16px',
    borderBottom: '1px solid #ebebeb',
    display: 'flex',
    alignItems: 'center',
  },
  modalTitle: {
    margin: '0px',
    ...fontDefault,
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#0e162c',
  },
  modalContent: {
    padding: '16px',
  },
  modalDesc: {
    margin: '0px',
    ...fontDefault,
    fontSize: '14px',
    color: '#878b96',
  },
  groupContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 16px 0px 16px',
  },
  groupLogo: {
    width: '56px',
    height: '56px',
  },
  groupText: {
    ...fontDefault,
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'white',
    marginTop: '0px',
    display: 'block',
  },
  pageTitleDetail: {
    ...fontDefault,
    fontSize: '18px',
    color: 'white',
  },
}

const scrollToRef = ref => {
  if (ref && ref.offsetTop) {
    document.getElementById('rootScreen').scrollTo(0, ref.offsetTop)
  }
}

const checkID = id => {
  if (id.length !== 13) return false
  let i = 0
  let sum = 0
  for (i = 0, sum = 0; i < 12; i++) sum += parseFloat(id.charAt(i)) * (13 - i)
  if ((11 - (sum % 11)) % 10 !== parseFloat(id.charAt(12))) return false
  return true
}

class PersonalInfo extends Component {
  state = {
    licensePlate: '',
    licensePlateError: false,
    vehicleID: '',
    vehicleIDError: false,
    ID: '',
    IDError: false,
    fullname: '',
    fullnameError: false,
    surnameError: false,
    effDate: moment().format('YYYY-MM-DD'),
    effDateError: false,
    birthdate: '',
    birthdateError: false,
    phoneNumber: '',
    phoneNumberError: false,
    address: '',
    addressError: false,
    email: '',
    emailError: false,
    plateProvinceError: false,
    genderError: false,
    moreAddressError: false,
    carBrandError: false,
    carModelError: false,
    carYearError: false,
    showBrandPicker: false,
    showModelPicker: false,
    showYearPicker: false,
    datePickerBirthdate: false,
    datePickerEffDate: false,
    modalVisible: false,
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    this.save()
    push('/select-package')
    document.getElementById('rootScreen').scrollTo(0, 0)
  }

  goToNextPage = async () => {
    if (this.validate()) {
      await this.save()
      const { auth, motor, system } = this.props
      const allData = {
        auth,
        system,
        motor,
      }
      sessionStorage.setItem('allData', JSON.stringify(allData))
      sessionStorage.setItem('lastSaveAll', new Date().getTime())
      const {
        history: { push },
      } = this.props
      this.save()
      push('/summary')
      document.getElementById('rootScreen').scrollTo(0, 0)
    }
  }

  openBrandPicker = () => {
    this.setState({
      showBrandPicker: true,
      carBrandError: false,
    })
  }

  closeBrandPicker = () => {
    this.setState({
      showBrandPicker: false,
    })
  }

  openModelPicker = () => {
    this.setState({
      showModelPicker: true,
      carModelError: false,
    })
  }

  closeModelPicker = () => {
    this.setState({
      showModelPicker: false,
    })
  }

  openYearPicker = () => {
    this.setState({
      showYearPicker: true,
      carYearError: false,
    })
  }

  closeYearPicker = () => {
    this.setState({
      showYearPicker: false,
    })
  }

  openProvincePicker = () => {
    this.setState({
      showProvincePicker: true,
      plateProvinceError: false,
    })
  }

  closeProvincePicker = () => {
    this.setState({
      showProvincePicker: false,
    })
  }

  openGenderPicker = () => {
    this.setState({
      showGenderPicker: true,
      genderError: false,
    })
  }

  closeGenderPicker = () => {
    this.setState({
      showGenderPicker: false,
    })
  }

  openAddressPicker = () => {
    this.setState({
      showAddressPicker: true,
      addressError: false,
    })
  }

  closeAddressPicker = () => {
    this.setState({
      showAddressPicker: false,
    })
  }
  validate = () => {
    const {
      currentProduct,
      plateProvince,
      gender,
      moreAddress,
      carBrand,
      carModel,
      carYear,
    } = this.props
    const {
      licensePlate,
      vehicleID,
      ID,
      fullname,
      birthdate,
      phoneNumber,
      address,
      email,
      effDate,
    } = this.state
    let valid = true
    let scroll = false
    if (!licensePlate) {
      valid = false
      this.setState({
        licensePlateError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.licensePlate', {}))
      if (!scroll) scroll = true
    }
    if (!licensePlate.match(/^[0-9ก-ฮ][ก-ฮ][ก-ฮ]?[0-9]{1,4}$/)) {
      valid = false
      this.setState({
        licensePlateError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.licensePlate', {}))
      if (!scroll) scroll = true
    }
    if (!vehicleID) {
      valid = false
      this.setState({
        vehicleIDError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.vehicleID', {}))
      if (!scroll) scroll = true
    }
    if (!vehicleID.match(/^[^\Wioq]{17}$/)) {
      valid = false
      this.setState({
        vehicleIDError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.vehicleID', {}))
      if (!scroll) scroll = true
    }
    if (!ID) {
      valid = false
      this.setState({
        IDError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.ID', {}))
      if (!scroll) scroll = true
    }
    if (!ID.match(/\d{13}/)) {
      valid = false
      this.setState({
        IDError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.ID', {}))
      if (!scroll) scroll = true
    }
    if (!checkID(ID)) {
      valid = false
      this.setState({
        IDError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.ID', {}))
      if (!scroll) scroll = true
    }
    if (!fullname) {
      valid = false
      this.setState({
        fullnameError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.fullname', {}))
      if (!scroll) scroll = true
    }
    if (fullname.split(/ +/).length < 2) {
      valid = false
      this.setState({
        surnameError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.fullname', {}))
      if (!scroll) scroll = true
    }
    if (!birthdate) {
      valid = false
      this.setState({
        birthdateError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.birthdate', {}))
      if (!scroll) scroll = true
    }
    if (!!birthdate) {
      const birthData = new Date(birthdate + 'T07:00:00')
      const eightYearAgo = new Date(
        moment()
          .subtract(18, 'years')
          .format('YYYY-MM-DD') + 'T07:00:00'
      )
      if (birthData.getTime() > eightYearAgo.getTime()) {
        valid = false
        this.setState({
          birthdateError: true,
        })
        if (!scroll) scrollToRef(_.get(this, 'refs.birthdate', {}))
        if (!scroll) scroll = true
      }
    }
    if (!effDate) {
      valid = false
      this.setState({
        effDateError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.effDate', {}))
      if (!scroll) scroll = true
    }
    if (!!effDate) {
      const effData = new Date(effDate + 'T07:00:00')
      const toDay = new Date(moment().format('YYYY-MM-DD') + 'T07:00:00')
      if (effData.getTime() < toDay.getTime()) {
        valid = false
        this.setState({
          effDateError: true,
        })
        if (!scroll) scrollToRef(_.get(this, 'refs.effDate', {}))
        if (!scroll) scroll = true
      }
    }
    if (!phoneNumber) {
      valid = false
      this.setState({
        phoneNumberError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.phoneNumber', {}))
      if (!scroll) scroll = true
    }
    if (
      !phoneNumber.match(
        /^(((0|\+66)[0-9]-?([0-9]{1})?))-?([0-9]{3})-?([0-9]{3,4})$/
      )
    ) {
      valid = false
      this.setState({
        phoneNumberError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.phoneNumber', {}))
      if (!scroll) scroll = true
    }
    if (!address) {
      valid = false
      this.setState({
        addressError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.address', {}))
      if (!scroll) scroll = true
    }
    if (!email) {
      valid = false
      this.setState({
        emailError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.email', {}))
      if (!scroll) scroll = true
    }
    if (
      !email.match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      valid = false
      this.setState({
        emailError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.email', {}))
      if (!scroll) scroll = true
    }
    if (!_.get(plateProvince, 'name', '')) {
      valid = false
      this.setState({
        plateProvinceError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.plateProvince', {}))
      if (!scroll) scroll = true
    }
    if (!gender) {
      valid = false
      this.setState({
        genderError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.gender', {}))
      if (!scroll) scroll = true
    }
    if (!_.get(moreAddress, 'fullAddress', '')) {
      valid = false
      this.setState({
        moreAddressError: true,
      })
      if (!scroll) scrollToRef(_.get(this, 'refs.moreAddress', {}))
      if (!scroll) scroll = true
    }
    if (currentProduct === 'C') {
      if (!carBrand) {
        valid = false
        this.setState({
          carBrandError: true,
        })
        if (!scroll) scrollToRef(_.get(this, 'refs.carBrand', {}))
        if (!scroll) scroll = true
      }
      if (!carModel) {
        valid = false
        this.setState({
          carModelError: true,
        })
        if (!scroll) scrollToRef(_.get(this, 'refs.carModel', {}))
        if (!scroll) scroll = true
      }
      if (!carYear) {
        valid = false
        this.setState({
          carYearError: true,
        })
        if (!scroll) scrollToRef(_.get(this, 'refs.carYear', {}))
        if (!scroll) scroll = true
      }
    }
    return valid
  }

  componentDidMount = () => {
    const {
      licensePlate,
      vehicleID,
      ID,
      fullname,
      birthdate,
      phoneNumber,
      address,
      email,
      auth,
      effDate,
    } = this.props
    this.setState({
      licensePlate,
      vehicleID,
      ID,
      fullname,
      phoneNumber,
      address,
      email,
    })
    if (effDate) {
      this.setState({
        effDate,
      })
    }
    const firstnamePrefill =
      _.get(auth, 'public_profile.firstname_th', '') ||
      _.get(auth, 'firstname_th', '')
    const lastnamePrefill =
      _.get(auth, 'public_profile.lastname_th', '') ||
      _.get(auth, 'lastname_th', '')
    const IDPrefill = (
      _.get(auth, 'thai_id_mask', '') ||
      _.get(auth, 'public_profile.thai_id_mask', '')
    ).replaceAll('-', '')
    let addressPrefill = _.get(auth, 'current_address.address', '')
    const mobilePrefill = _.get(auth, 'mobile', '')
    const birthdatePrefill = _.get(auth, 'date_of_birth', '')
    if (!!birthdate) {
      this.setState({
        birthdate,
      })
    } else if (birthdatePrefill) {
      this.setState({
        birthdate: birthdatePrefill,
      })
    } else {
      this.setState({
        birthdate: moment()
          .subtract(18, 'years')
          .format('YYYY-MM-DD'),
      })
    }
    if (mobilePrefill && phoneNumber.length === 0) {
      this.setState({
        phoneNumber: mobilePrefill,
      })
    }
    if (firstnamePrefill && lastnamePrefill && fullname.length === 0) {
      this.setState({
        fullname: firstnamePrefill + ' ' + lastnamePrefill,
      })
    }
    if (IDPrefill && ID.length === 0) {
      this.setState({
        ID: IDPrefill,
      })
    }

    // prefill address
    let provincePrefill = _.get(auth, 'current_address.province', '')
    // new
    let sub_district = _.get(auth, 'current_address.sub_district', '')
    let district = _.get(auth, 'current_address.district', '')
    let plain_address = _.get(auth, 'current_address.plain_address', '')
    let postalCodePrefill = _.get(auth, 'current_address.postal_code', '')

    let provinceData = provinces.find(p => {
      return p.jw_name === provincePrefill
    })
    if (!!provinceData === false) {
      const foundID = Object.keys(subdistricts).find(sid => {
        return (
          _.get(_.get(subdistricts, sid, []), '0.zipcode', '') ===
          postalCodePrefill
        )
      })
      if (!!foundID) {
        const foundJWCode = _.get(subdistricts, foundID + '.0.jw_code', '')
        if (foundJWCode) {
          provinceData = provinces.find(p => {
            return p.jw_code === foundJWCode
          })
        }
      }
    }
    let setAddress = false
    if (provinceData && !!sub_district && !!district && !!plain_address) {
      const thisAmphDistrict = _.get(
        districts,
        _.get(provinceData, 'jw_code', false),
        {}
      )
      const amphData = thisAmphDistrict.find(am => {
        return am.name === district || am.name === 'เขต' + district
      })
      if (amphData) {
        const mixID =
          _.get(provinceData, 'jw_code', '') +
          '-' +
          _.get(amphData, 'amph_code', '')
        const thisSubDistrict = _.get(subdistricts, mixID, [])
        const tumbonData = thisSubDistrict.find(tb => {
          return tb.name === sub_district
        })
        if (tumbonData) {
          const fullAddress =
            _.get(provinceData, 'jw_name', '') +
            ' - ' +
            _.get(amphData, 'name', '') +
            ' - ' +
            _.get(tumbonData, 'name', '') +
            ' ' +
            _.get(tumbonData, 'zipcode', '')
          const moreAddress = {
            province: provinceData,
            district: amphData,
            subdistrict: tumbonData,
            fullAddress,
          }
          const { setUserInput } = this.props
          setUserInput({
            moreAddress,
          })
          addressPrefill = plain_address
          setAddress = true
        }
      }
    }
    if (provinceData && setAddress === false) {
      const thisAmphDistrict = _.get(
        districts,
        _.get(provinceData, 'jw_code', false),
        {}
      )
      const splitAddress = addressPrefill.split(' ')
      const guessDistrictName = splitAddress[splitAddress.length - 1]
      const guessDistrictNameWithoutProvince = guessDistrictName
        .split(_.get(provinceData, 'jw_name', ''))
        .join('')
      const guessSubDistrictName = splitAddress[splitAddress.length - 2]
      const amphData = thisAmphDistrict.find(am => {
        return (
          am.name === guessDistrictName ||
          am.name === 'เขต' + guessDistrictName ||
          am.name === guessDistrictNameWithoutProvince ||
          am.name === 'เขต' + guessDistrictNameWithoutProvince
        )
      })
      if (amphData) {
        const mixID =
          _.get(provinceData, 'jw_code', '') +
          '-' +
          _.get(amphData, 'amph_code', '')
        const thisSubDistrict = _.get(subdistricts, mixID, [])
        const tumbonData = thisSubDistrict.find(tb => {
          return tb.name === guessSubDistrictName
        })
        if (tumbonData) {
          const fullAddress =
            _.get(provinceData, 'jw_name', '') +
            ' - ' +
            _.get(amphData, 'name', '') +
            ' - ' +
            _.get(tumbonData, 'name', '') +
            ' ' +
            _.get(tumbonData, 'zipcode', '')
          const moreAddress = {
            province: provinceData,
            district: amphData,
            subdistrict: tumbonData,
            fullAddress,
          }
          const { setUserInput } = this.props
          setUserInput({
            moreAddress,
          })
          addressPrefill = splitAddress.slice(0, splitAddress.length - 3)
        }
      }
    }
    if (addressPrefill && address.length === 0) {
      if (
        typeof addressPrefill === 'object' &&
        typeof addressPrefill.join === 'function'
      ) {
        addressPrefill = addressPrefill.join(' ')
      }
      if ((addressPrefill || '').length >= 30) {
        addressPrefill = addressPrefill.slice(0, 30)
      }
      this.setState({
        address: addressPrefill,
      })
    }
  }

  save = async () => {
    const { setUserInput } = this.props
    const {
      licensePlate,
      vehicleID,
      ID,
      fullname,
      birthdate,
      phoneNumber,
      address,
      email,
      effDate,
    } = this.state
    await setUserInput({
      licensePlate,
      vehicleID,
      ID,
      fullname,
      birthdate,
      phoneNumber,
      address,
      email,
      effDate,
    })
  }

  render() {
    const {
      classes,
      plateProvince,
      gender,
      moreAddress,
      selectPrice,
      currentProduct,
      carBrand,
      carModel,
      carYear,
      currentPackage,
      auth,
    } = this.props
    const {
      licensePlate,
      licensePlateError,
      vehicleID,
      vehicleIDError,
      ID,
      IDError,
      effDate,
      effDateError,
      fullname,
      fullnameError,
      surnameError,
      birthdate,
      birthdateError,
      phoneNumber,
      phoneNumberError,
      address,
      addressError,
      email,
      emailError,
      plateProvinceError,
      genderError,
      moreAddressError,
      carBrandError,
      carModelError,
      carYearError,
      showBrandPicker,
      showModelPicker,
      showYearPicker,
      showProvincePicker,
      showGenderPicker,
      showAddressPicker,
      datePickerBirthdate,
      datePickerEffDate,
      modalVisible,
    } = this.state
    let effDateLower = false
    if (effDate) {
      const effData = new Date(effDate + 'T07:00:00')
      const toDay = new Date(moment().format('YYYY-MM-DD') + 'T07:00:00')
      effDateLower = effData.getTime() < toDay.getTime()
    }
    let birthdateYounger = false
    if (birthdate) {
      const birthData = new Date(birthdate + 'T07:00:00')
      const eightYearAgo = new Date(
        moment()
          .subtract(18, 'years')
          .format('YYYY-MM-DD') + 'T07:00:00'
      )
      birthdateYounger = birthData.getTime() > eightYearAgo.getTime()
    }
    const insufficientFund =
      parseFloat(
        _.get(auth, 'balance', 0) || _.get(auth, 'public_profile.balance', 0)
      ) /
        100 <
      parseFloat(selectPrice)
    return (
      <Wrapper>
        <Body style={{ backgroundColor: '#eff0f4' }}>
          <div className={classes.backgroundImageContainer}>
            <img
              alt="background_image"
              className={classes.backgroundImage}
              src={BackgroundImage}
            />
          </div>
          <div
            className={classes.container}
            style={insufficientFund ? { marginTop: '60px' } : {}}
          >
            <Grid container>
              {currentProduct === 'C' && (
                <Grid item xs={12}>
                  <div className={classes.groupContainer}>
                    <img src={GroupImage} className={classes.groupLogo} />
                    <div style={{ marginLeft: '16px' }}>
                      <span className={classes.groupText}>แผนประกันภัย</span>
                      <span className={classes.pageTitleDetail}>
                        พ.ร.บ. รถยนต์{' ฿ '}
                        {numeral(
                          parseFloat(
                            _.get(currentPackage, 'total_prem', 999999)
                          )
                        ).format('0,0.00')}
                      </span>
                    </div>
                  </div>
                </Grid>
              )}
              {currentProduct === 'V' && (
                <Grid item xs={12}>
                  <div className={classes.groupContainer}>
                    <img src={GroupImage} className={classes.groupLogo} />
                    <div style={{ marginLeft: '16px' }}>
                      <span className={classes.groupText}>
                        แผนประกันรถยนต์สำหรับ
                      </span>
                      <span className={classes.pageTitleDetail}>
                        {carBrand} {_.get(carModel, 'label', '')} {carYear}
                      </span>
                    </div>
                  </div>
                </Grid>
              )}
              <Grid item xs={12}>
                {currentProduct === 'C' && (
                  <div className={classes.card}>
                    <div className={classes.cardHeader}>
                      <span className={classes.cardTitle}>
                        ข้อมูลเกี่ยวกับรถ
                      </span>
                    </div>
                    <div className={classes.cardContent}>
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          เลือกยี่ห้อรถยนต์
                        </span>
                        <div
                          ref="carBrand"
                          className={
                            carBrandError
                              ? classes.inputContainerError
                              : classes.inputContainer
                          }
                          onClick={this.openBrandPicker}
                        >
                          <span
                            className={
                              carBrand
                                ? classes.fieldValue
                                : classes.fieldValueBlank
                            }
                          >
                            {carBrand ? carBrand : 'เลือก'}
                          </span>
                          <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                            arrow_forward_ios
                          </Icon>
                        </div>
                        {carBrandError && (
                          <span className={classes.errorText}>
                            กรุณาเลือกยี่ห้อรถยนต์
                          </span>
                        )}
                      </div>
                      <br />
                      <div
                        className={classes.fieldContainer}
                        onClick={() => {
                          if (carBrand) {
                            this.openModelPicker()
                          }
                        }}
                      >
                        <span className={classes.fieldTitle}>
                          เลือกรุ่นรถยนต์
                        </span>
                        <div
                          ref="carModel"
                          className={
                            carBrand
                              ? carModelError
                                ? classes.inputContainerError
                                : classes.inputContainer
                              : carModelError
                              ? classes.inputContainerDisableError
                              : classes.inputContainerDisable
                          }
                        >
                          <span
                            className={
                              carModel
                                ? classes.fieldValue
                                : classes.fieldValueBlank
                            }
                          >
                            {carModel ? _.get(carModel, 'label', '') : 'เลือก'}
                          </span>
                          <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                            arrow_forward_ios
                          </Icon>
                        </div>
                        {carModelError && (
                          <span className={classes.errorText}>
                            กรุณาเลือกรุ่นรถยนต์
                          </span>
                        )}
                      </div>
                      <br />
                      <div
                        className={classes.fieldContainer}
                        onClick={() => {
                          if (carBrand && carModel) {
                            this.openYearPicker()
                          }
                        }}
                      >
                        <span className={classes.fieldTitle}>
                          เลือกปีที่จดทะเบียน
                        </span>
                        <div
                          ref="carYear"
                          className={
                            carBrand && carModel
                              ? carYearError
                                ? classes.inputContainerError
                                : classes.inputContainer
                              : carYearError
                              ? classes.inputContainerDisableError
                              : classes.inputContainerDisable
                          }
                        >
                          <span
                            className={
                              carYear
                                ? classes.fieldValue
                                : classes.fieldValueBlank
                            }
                          >
                            {carYear ? carYear : 'เลือก'}
                          </span>
                          <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                            arrow_forward_ios
                          </Icon>
                        </div>
                        {carYearError && (
                          <span className={classes.errorText}>
                            กรุณาเลือกปีที่ผลิต
                          </span>
                        )}
                      </div>
                      <br />
                    </div>
                  </div>
                )}
                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>ข้อมูลรถยนต์</span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>ทะเบียนรถ</span>
                      <div
                        ref="licensePlate"
                        className={
                          licensePlateError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={licensePlate}
                          onChange={event => {
                            this.setState({
                              licensePlate: event.target.value,
                              licensePlateError: false,
                            })
                          }}
                          className={classes.fieldInput}
                          type="text"
                          placeholder="กรอกเลขทะเบียนรถ"
                        />
                      </div>
                      {licensePlateError && (
                        <span className={classes.errorText}>
                          {licensePlate.length !== 0
                            ? 'เลขทะเบียนรถไม่ถูกต้อง'
                            : 'กรุณากรอกเลขทะเบียนรถ'}
                        </span>
                      )}
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={this.openProvincePicker}
                    >
                      <span className={classes.fieldTitle}>ทะเบียนจังหวัด</span>
                      <div
                        ref="plateProvince"
                        className={
                          plateProvinceError
                            ? classes.inputContainerError
                            : classes.inputContainer
                        }
                      >
                        <span
                          className={
                            _.get(plateProvince, 'name', '')
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {_.get(plateProvince, 'name', '')
                            ? _.get(plateProvince, 'name', '')
                            : 'เลือกจังหวัด'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                      {plateProvinceError && (
                        <span className={classes.errorText}>
                          กรุณาเลือกจังหวัด
                        </span>
                      )}
                    </div>
                    <br />
                    <div className={classes.fieldContainer}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className={classes.fieldTitle}>เลขตัวถัง</span>
                        <div
                          className={classes.button}
                          onClick={() => {
                            this.setState({
                              modalVisible: true,
                            })
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <ellipse
                              cx="9"
                              cy="9.04757"
                              rx="9"
                              ry="8.64986"
                              fill="#333333"
                            />
                            <path
                              d="M8.19141 10.6654H9.9375V12.3588H8.19141V10.6654ZM6.05273 6.44666C6.09961 5.33337 6.48828 4.54431 7.21875 4.07947C7.67969 3.78259 8.24609 3.63416 8.91797 3.63416C9.80078 3.63416 10.5332 3.84509 11.1152 4.26697C11.7012 4.68884 11.9941 5.31384 11.9941 6.14197C11.9941 6.64978 11.8672 7.07751 11.6133 7.42517C11.4648 7.63611 11.1797 7.90564 10.7578 8.23376L10.3418 8.55603C10.1152 8.73181 9.96484 8.93689 9.89062 9.17126C9.84375 9.3197 9.81836 9.55017 9.81445 9.86267H8.23242C8.25586 9.20251 8.31836 8.74744 8.41992 8.49744C8.52148 8.24353 8.7832 7.95251 9.20508 7.62439L9.63281 7.29041C9.77344 7.18494 9.88672 7.0697 9.97266 6.9447C10.1289 6.72986 10.207 6.49353 10.207 6.23572C10.207 5.93884 10.1191 5.66931 9.94336 5.42712C9.77148 5.18103 9.45508 5.05798 8.99414 5.05798C8.54102 5.05798 8.21875 5.20837 8.02734 5.50916C7.83984 5.80994 7.74609 6.12244 7.74609 6.44666H6.05273Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                      <div
                        ref="vehicleID"
                        className={
                          vehicleIDError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={vehicleID}
                          onChange={event => {
                            this.setState({
                              vehicleID: event.target.value,
                              vehicleIDError: false,
                            })
                          }}
                          className={classes.fieldInput}
                          style={{ textTransform: 'uppercase' }}
                          type="text"
                          placeholder="กรอกเลขตัวถัง"
                        />
                      </div>
                      {vehicleIDError && (
                        <span className={classes.errorText}>
                          {vehicleID.length === 0
                            ? 'กรุณากรอกเลขตัวถัง'
                            : 'เลขตัวถังไม่ถูกต้อง'}
                        </span>
                      )}
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                        this.setState({
                          datePickerEffDate: true,
                        })
                      }}
                    >
                      <span className={classes.fieldTitle}>
                        คุ้มครอง 1 ปีนับตั้งแต่วันที่
                      </span>
                      <div
                        ref="effDate"
                        className={
                          effDateError
                            ? classes.inputContainerError
                            : classes.inputContainer
                        }
                      >
                        <span
                          className={
                            effDate
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {effDate ? dateStringToText(effDate) : 'เลือกข้อมูล'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                      {effDateError && (
                        <span className={classes.errorText}>
                          {effDateLower
                            ? 'วันที่เริ่มคุ้มครองไม่สามารถเป็นวันในอดีต'
                            : 'กรุณาเลือกข้อมูล'}
                        </span>
                      )}
                    </div>
                    <br />
                  </div>
                </div>

                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>
                      ข้อมูลผู้ถือกรมธรรม์
                    </span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>เลขบัตรประชาชน</span>
                      <div
                        ref="ID"
                        className={
                          IDError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={ID}
                          onChange={event => {
                            this.setState({
                              ID: event.target.value,
                              IDError: false,
                            })
                          }}
                          className={classes.fieldInput}
                          type="text"
                          placeholder="กรอกเลขบัตรประชาชน"
                        />
                      </div>
                      {IDError && (
                        <span className={classes.errorText}>
                          {ID.length === 0
                            ? 'กรุณากรอกเลขบัตรประชาชน'
                            : 'เลขบัตรประชาชนไม่ถูกต้อง'}
                        </span>
                      )}
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={this.openGenderPicker}
                    >
                      <span className={classes.fieldTitle}>คำนำหน้า</span>
                      <div
                        ref="gender"
                        className={
                          genderError
                            ? classes.inputContainerError
                            : classes.inputContainer
                        }
                      >
                        <span
                          className={
                            gender
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {gender ? gender : 'เลือกคำนำหน้า'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                      {genderError && (
                        <span className={classes.errorText}>
                          กรุณาเลือกตำนำหน้า
                        </span>
                      )}
                    </div>
                    <br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>ชื่อ - นามสกุล</span>
                      <div
                        ref="fullname"
                        className={
                          fullnameError || surnameError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={fullname}
                          onChange={event => {
                            this.setState({
                              fullname: event.target.value,
                              fullnameError: false,
                              surnameError: false,
                            })
                          }}
                          className={classes.fieldInput}
                          type="text"
                          placeholder="กรอกชื่อ - นามสกุล"
                        />
                      </div>
                      {fullnameError && (
                        <span className={classes.errorText}>
                          กรุณากรอกชื่อ - นามสกุล
                        </span>
                      )}
                      {surnameError && (
                        <span className={classes.errorText}>
                          กรุณากรอกนามสกุล
                        </span>
                      )}
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                        this.setState({
                          datePickerBirthdate: true,
                        })
                      }}
                    >
                      <span className={classes.fieldTitle}>
                        วัน / เดือน / ปีเกิด
                      </span>
                      <div
                        ref="birthdate"
                        className={
                          birthdateError
                            ? classes.inputContainerError
                            : classes.inputContainer
                        }
                      >
                        <span
                          className={
                            birthdate
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {birthdate
                            ? dateStringToText(birthdate)
                            : 'กรอกวัน / เดือน / ปีเกิด'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                      {birthdateError && (
                        <span className={classes.errorText}>
                          {birthdateYounger
                            ? 'อายุต่ำกว่าเกณฑ์ที่กำหนด'
                            : 'กรุณาเลือกข้อมูล'}
                        </span>
                      )}
                    </div>
                    <br />
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>เบอร์โทรติดต่อ</span>
                      <div
                        ref="phoneNumber"
                        className={
                          phoneNumberError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={phoneNumber}
                          onChange={event => {
                            this.setState({
                              phoneNumber: event.target.value,
                              phoneNumberError: false,
                            })
                          }}
                          className={classes.fieldInput}
                          type="number"
                          placeholder="กรอกเบอร์โทรติดต่อ"
                        />
                      </div>
                      {phoneNumberError && (
                        <span className={classes.errorText}>
                          กรุณากรอกเบอร์โทรติดต่อ
                        </span>
                      )}
                    </div>
                    <br />
                  </div>
                </div>

                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>
                      ที่อยู่ผู้ถือกรมธรรม์
                    </span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>ที่อยู่</span>
                      <div
                        ref="address"
                        className={
                          addressError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={address}
                          onChange={event => {
                            if (event.target.value.length < 30) {
                              this.setState({
                                address: event.target.value,
                                addressError: false,
                              })
                            }
                          }}
                          maxLength="30"
                          className={classes.fieldInput}
                          type="text"
                          placeholder="กรอกที่อยู่"
                        />
                      </div>
                      {addressError && (
                        <span className={classes.errorText}>
                          กรอกบ้านเลขที่ ถนน
                        </span>
                      )}
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={this.openAddressPicker}
                    >
                      <span className={classes.fieldTitle}>
                        จังหวัด, อำเภอ, ตำบล
                      </span>
                      <div
                        ref="moreAddress"
                        className={
                          moreAddressError
                            ? classes.inputContainerError
                            : classes.inputContainer
                        }
                      >
                        <span
                          className={
                            _.get(moreAddress, 'fullAddress', '')
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {_.get(moreAddress, 'fullAddress', '')
                            ? _.get(moreAddress, 'fullAddress', '')
                            : 'เลือกข้อมูล'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                      {moreAddressError && (
                        <span className={classes.errorText}>
                          กรุณาเลือกข้อมูล
                        </span>
                      )}
                    </div>
                    <br />
                  </div>
                </div>

                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>
                      อีเมลสำหรับจัดส่งกรมธรรม์
                    </span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>อีเมล</span>
                      <div
                        ref="email"
                        className={
                          emailError
                            ? classes.inputContainerInputError
                            : classes.inputContainerInput
                        }
                      >
                        <input
                          value={email}
                          onChange={event => {
                            this.setState({
                              email: event.target.value,
                              emailError: false,
                            })
                          }}
                          className={classes.fieldInput}
                          type="text"
                          placeholder="กรอกอีเมล"
                        />
                      </div>
                      {emailError && (
                        <span className={classes.errorText}>
                          {email.length === 0
                            ? 'กรุณากรอกอีเมล'
                            : 'อีเมลไม่ถูกต้อง'}
                        </span>
                      )}
                    </div>
                    <br />
                    <span
                      style={{
                        ...fontDefault,
                        fontSize: '14px',
                        color: '#878b96',
                      }}
                    >
                      หากต้องการกรมธรรม์ทางไปรษณีย์
                      สามารถแจ้งที่อยู่จัดส่งเพิ่มเติมได้ที่ 02-285-8888
                    </span>
                    <br />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <BrandPicker
            open={showBrandPicker}
            onBack={this.closeBrandPicker}
            history={this.props.history}
          />
          <ModelPicker
            open={showModelPicker}
            onBack={this.closeModelPicker}
            history={this.props.history}
          />
          <YearPicker
            since={1994}
            open={showYearPicker}
            onBack={this.closeYearPicker}
            history={this.props.history}
          />
          <ProvincePicker
            open={showProvincePicker}
            onBack={this.closeProvincePicker}
            history={this.props.history}
          />
          <GenderPicker
            open={showGenderPicker}
            onBack={this.closeGenderPicker}
            history={this.props.history}
          />
          <AddressPicker
            open={showAddressPicker}
            onBack={this.closeAddressPicker}
            history={this.props.history}
          />
        </Body>
        <Footer style={{ backgroundColor: '#eff0f4' }}>
          <SubmitButton onClick={this.goToNextPage}>ถัดไป</SubmitButton>
        </Footer>
        <Header>
          <TopBar
            progress={currentProduct === 'V' ? 3 : 2}
            arrowLeft={this.backButton}
            insufficientFund={insufficientFund}
          >
            <Typography align="center" className={classes.textTopBar}>
              กรอกข้อมูล
            </Typography>
          </TopBar>
        </Header>
        <DatePicker
          value={new Date(birthdate + 'T07:00:00')}
          isOpen={datePickerBirthdate}
          onSelect={time => {
            this.setState({
              birthdate: moment(time).format('YYYY-MM-DD'),
              datePickerBirthdate: false,
              birthdateError: false,
            })
          }}
          onCancel={() => {
            this.setState({
              datePickerBirthdate: false,
            })
          }}
          confirmText="ตกลง"
          cancelText="ยกเลิก"
          showHeader={false}
          max={moment()
            .subtract(18, 'years')
            .toDate()}
          min={moment()
            .subtract(118, 'years')
            .toDate()}
          showCaption
          dateConfig={{
            date: {
              format: 'D',
              caption: 'วัน',
              step: 1,
            },
            month: {
              format: 'MMMM',
              caption: 'เดือน',
              step: 1,
            },
            year: {
              format: 'YYYYY',
              caption: 'ปี',
              step: 1,
            },
          }}
        />
        <DatePicker
          value={new Date(effDate + 'T07:00:00')}
          isOpen={datePickerEffDate}
          onSelect={time => {
            this.setState({
              effDate: moment(time).format('YYYY-MM-DD'),
              datePickerEffDate: false,
              effDateError: false,
            })
          }}
          onCancel={() => {
            this.setState({
              datePickerEffDate: false,
            })
          }}
          confirmText="ตกลง"
          cancelText="ยกเลิก"
          showHeader={false}
          min={moment()
            .subtract(1, 'day')
            .toDate()}
          max={moment()
            .add(6, 'months')
            .toDate()}
          showCaption
          dateConfig={{
            date: {
              format: 'D',
              caption: 'วัน',
              step: 1,
            },
            month: {
              format: 'MMMM',
              caption: 'เดือน',
              step: 1,
            },
            year: {
              format: 'YYYYY',
              caption: 'ปี',
              step: 1,
            },
          }}
        />
        <Modal
          styles={{ outline: 0 }}
          open={modalVisible}
          onClose={() => {
            this.setState({ modalVisible: false })
          }}
        >
          <div className={classes.modalContainer}>
            <IconButton
              className={classes.modalClose}
              onClick={() => {
                this.setState({ modalVisible: false })
              }}
            >
              <Icon style={{ fontSize: '18px', color: '#4A4A4A' }}>close</Icon>
            </IconButton>
            <div className={classes.modalHeader} style={{ height: '57px' }}>
              <p className={classes.modalTitle}>ตรวจสอบหมายเลขตัวถังได้ที่</p>
            </div>
            <div className={classes.modalContent}>
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: 'example image',
                    isFluidWidth: true,
                    src: newInfo,
                  },
                  largeImage: {
                    src: newInfo,
                    width: 858,
                    height: 547,
                  },
                  isHintEnabled: true,
                  shouldHideHintAfterFirstActivation: false,
                  enlargedImagePosition: 'over',
                  hintTextTouch: 'แตะเพื่อขยาย',
                  hintTextMouse: 'คลิกเพื่อขยาย',
                }}
              />
            </div>
          </div>
        </Modal>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    motor: state.motor,
    system: state.system,
    licensePlate: _.get(state, 'motor.userInput.licensePlate', ''),
    plateProvince: _.get(state, 'motor.userInput.plateProvince', {}),
    vehicleID: _.get(state, 'motor.userInput.vehicleID', ''),
    ID: _.get(state, 'motor.userInput.ID', ''),
    gender: _.get(state, 'motor.userInput.gender', ''),
    fullname: _.get(state, 'motor.userInput.fullname', ''),
    birthdate: _.get(state, 'motor.userInput.birthdate', ''),
    phoneNumber: _.get(state, 'motor.userInput.phoneNumber', ''),
    address: _.get(state, 'motor.userInput.address', ''),
    moreAddress: _.get(state, 'motor.userInput.moreAddress', {}),
    email: _.get(state, 'motor.userInput.email', ''),
    auth: _.get(state, 'auth', {}),
    balance: _.get(state, 'auth.balance', 0),
    selectPrice: _.get(state, 'motor.userInput.selectPrice', 0),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    currentPackage: _.get(state, 'motor.userInput.currentPackage', {}),
    carBrand: _.get(state, 'motor.userInput.carBrand', ''),
    carModel: _.get(state, 'motor.userInput.carModel', ''),
    carYear: _.get(state, 'motor.userInput.carYear', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PersonalInfo))
